import { SensorData } from 'Simulations/SensorPoint';
import { FilterStage, StageParameters } from '../../Stage';
import { StageContext } from '../../Context';

export type HideZeroValuesParameters = StageParameters & {};

class HideZeroValuesStage extends FilterStage<HideZeroValuesParameters> {
    constructor() {
        super({});
    }

    protected filter(sensorData: SensorData, _context: StageContext): boolean {
        if (sensorData.getScalarValue() === 0) {
            return false;
        }
        return true;
    }
}

export default HideZeroValuesStage;
